import RelationshipMetadata from "../../RelationshipMetadata";

class ETLJobExecutionETLJobExecutionLogRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "ETLJobExecutionETLJobExecutionLog";
        this.parentEnterpriseComponent = "ETLJobExecution";
        this.childEnterpriseComponent = "ETLJobExecutionLog";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "ETLJobExecutionUSID";
    }
}

export default ETLJobExecutionETLJobExecutionLogRelationshipMetadata;